import { render, staticRenderFns } from "./common-down.vue?vue&type=template&id=5e4f8bc4&scoped=true&"
import script from "./common-down.vue?vue&type=script&lang=js&"
export * from "./common-down.vue?vue&type=script&lang=js&"
import style0 from "./common-down.vue?vue&type=style&index=0&id=5e4f8bc4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f8bc4",
  null
  
)

export default component.exports